import React from 'react'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

interface Props {
  width?: number
  height?: number
  color?: string
}

const PendingIcon: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#8C6500',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 20 20" fill="none">
      <G clipPath="url(#clip0_4254_12484)">
        {/* Top vertical bar */}
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 2.70312C10.4142 2.70312 10.75 3.03891 10.75 3.45312V5.63444C10.75 6.04865 10.4142 6.38444 10 6.38444C9.58579 6.38444 9.25 6.04865 9.25 5.63444V3.45312C9.25 3.03891 9.58579 2.70312 10 2.70312Z"
          fill={color}
        />

        {/* Right horizontal bar */}
        <Path
          opacity="0.8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6094 10C13.6094 9.58579 13.9452 9.25 14.3594 9.25H16.5407C16.9549 9.25 17.2907 9.58579 17.2907 10C17.2907 10.4142 16.9549 10.75 16.5407 10.75H14.3594C13.9452 10.75 13.6094 10.4142 13.6094 10Z"
          fill={color}
        />

        {/* Bottom right diagonal */}
        <Path
          opacity="0.7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5478 12.5478C12.8407 12.2549 13.3156 12.2549 13.6085 12.5478L15.1511 14.0904C15.4439 14.3833 15.4439 14.8582 15.1511 15.1511C14.8582 15.4439 14.3833 15.4439 14.0904 15.1511L12.5478 13.6085C12.2549 13.3156 12.2549 12.8407 12.5478 12.5478Z"
          fill={color}
        />

        {/* Bottom vertical bar */}
        <Path
          opacity="0.6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 13.6094C10.4142 13.6094 10.75 13.9452 10.75 14.3594V16.5407C10.75 16.9549 10.4142 17.2907 10 17.2907C9.58579 17.2907 9.25 16.9549 9.25 16.5407V14.3594C9.25 13.9452 9.58579 13.6094 10 13.6094Z"
          fill={color}
        />

        {/* Bottom left diagonal */}
        <Path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.44012 12.5478C7.73301 12.8407 7.73301 13.3156 7.44012 13.6085L5.89752 15.1511C5.60462 15.4439 5.12975 15.4439 4.83686 15.1511C4.54396 14.8582 4.54396 14.3833 4.83686 14.0904L6.37946 12.5478C6.67235 12.2549 7.14722 12.2549 7.44012 12.5478Z"
          fill={color}
        />

        {/* Left horizontal bar */}
        <Path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.70312 10C2.70312 9.58579 3.03891 9.25 3.45312 9.25H5.63444C6.04865 9.25 6.38444 9.58579 6.38444 10C6.38444 10.4142 6.04865 10.75 5.63444 10.75H3.45312C3.03891 10.75 2.70312 10.4142 2.70312 10Z"
          fill={color}
        />

        {/* Top right diagonal */}
        <Path
          opacity="0.9"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1553 4.84185C15.4482 5.13475 15.4482 5.60962 15.1553 5.90251L13.6129 7.44494C13.32 7.73783 12.8451 7.73783 12.5522 7.44494C12.2594 7.15204 12.2594 6.67717 12.5522 6.38428L14.0947 4.84185C14.3876 4.54896 14.8624 4.54896 15.1553 4.84185Z"
          fill={color}
        />

        {/* Top left diagonal */}
        <Path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.83686 4.84467C5.12975 4.55178 5.60462 4.55178 5.89752 4.84467L7.44012 6.38727C7.73301 6.68016 7.73301 7.15504 7.44012 7.44793C7.14722 7.74082 6.67235 7.74082 6.37946 7.44793L4.83686 5.90533C4.54396 5.61244 4.54396 5.13756 4.83686 4.84467Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_4254_12484">
          <Rect width="20" height="20" rx="10" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default PendingIcon
